import {
  type ExtractDocumentTypeFromTypedRxJsonSchema,
  type RxCollection,
  type RxJsonSchema,
  toTypedRxJsonSchema,
} from "rxdb";
import { useRxCollection, type useRxData } from "rxdb-hooks";
import { SYNCABLE_META } from "./common";

export const RXDB_REFERRAL_FEEDBACK_COLLECTION_NAME = "referral-feedback";

export const useRxCollectionReferralFeedback =
  (): RxCollection<ReferralFeedback> | null =>
    useRxCollection<ReferralFeedback>(RXDB_REFERRAL_FEEDBACK_COLLECTION_NAME);

type UseRxData = Parameters<typeof useRxData<ReferralFeedback>>;
export type ReferralFeedbackQueryConstructor = UseRxData["1"];

const REFERRAL_FEEDBACK_SCHEMA_LITERAL = {
  title: "referral feedback schema",
  version: 3,
  description: "Represents feedback on a patient referral",
  type: "object",
  primaryKey: "id",
  properties: {
    id: {
      type: "string",
      maxLength: 100,
    },
    meta: SYNCABLE_META,
    referralId: { type: "string" },
    patientId: { type: "string" },
    feedbackType: {
      type: "string",
      enum: [
        "APPROPRIATE",
        "WRONG_FACILITY",
        "NOT_NEEDED",
        "INSUFFICIENT_DETAIL",
      ],
    },
  },
  required: ["id", "meta", "referralId", "patientId", "feedbackType"],
  /*
   * It is important to set 'as const' to preserve the literal type.
   *
   * biome-ignore lint/suspicious/noExplicitAny: We infer the DB type from this
   * object, the satisfies just provides us type inference for this object.
   */
} as const satisfies RxJsonSchema<any>;

const schemaTyped = toTypedRxJsonSchema(REFERRAL_FEEDBACK_SCHEMA_LITERAL);

export type ReferralFeedback = ExtractDocumentTypeFromTypedRxJsonSchema<
  typeof schemaTyped
>;

export const REFERRAL_FEEDBACK_SCHEMA: RxJsonSchema<ReferralFeedback> =
  REFERRAL_FEEDBACK_SCHEMA_LITERAL;
